module.exports = __webpack_public_path__ + "img/info-gray.b93ca8a4.svg";